import React from 'react'

function Btn({children,disabled,btnClick,dblClick=()=>{},Cls='',Stl=undefined,cont=null}){
    let timerId
    const click=()=>{
        if(!btnClick) return
        if(!timerId) timerId = setTimeout(()=>{clearTimeout(timerId);timerId=undefined;btnClick()},250)
    }
    const dbclck=()=>{
        if(timerId) clearTimeout(timerId)
        timerId=undefined
        dblClick()
    }
    //console.log(Stl)
    /*if(cont){
        if (Stl===''){
            return (!disabled ? (<div className={'button '+Cls} tabIndex='0' onDoubleClick={dbclck} onClick={click} onKeyUp={(e)=>{if(e.key === 'Enter') btnClick()}}>{children}</div>)
            :(<div className={'button disabled '+Cls}>{children}</div>))
        } else {
            return (!disabled ? (<div className={'button '+Cls} style={Stl} tabIndex='0' onDoubleClick={dbclck} onClick={click} onKeyUp={(e)=>{if(e.key === 'Enter') btnClick()}}>{children}</div>)
            :(<div className={'button disabled '+Cls} style={Stl}>{children}</div>))
        }
    }*/
    if (Stl===''){
        return (!disabled ? (<div className={'button '+Cls} tabIndex='0' onDoubleClick={dbclck} onClick={click} onKeyUp={(e)=>{if(e.key === 'Enter') btnClick()}}>{children}{cont}</div>)
        :(<div className={'button disabled '+Cls}>{children}{cont}</div>))
    } else {
        return (!disabled ? (<div className={'button '+Cls} style={Stl} tabIndex='0' onDoubleClick={dbclck} onClick={click} onKeyUp={(e)=>{if(e.key === 'Enter') btnClick()}}>{children}{cont}</div>)
        :(<div className={'button disabled '+Cls} style={Stl}>{children}{cont}</div>))
    }
}

export default Btn